// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1ItPU","footer":"ModalInfo_footer__2zi5Q"};